var getReqParam;
// var fs = require('fs');
var aesjs = require('aes-js');
var aes_key = [0, 1, 2, 3, 4, 5, 6, 7, 8, 22, 33, 55, 120, 12, 76, 87];
//Begin public method /getReqParam/
getReqParam = function(req, dontTransStrToValue) {
  var obj, prop, val;
  switch (req.method) {
    case 'GET':
      obj = req.query;
      break;
    case 'POST':
      obj = req.body;
      break;
    default:
      obj = {};
  }
  if (!dontTransStrToValue) {
    for (prop in obj) {
      val = obj[prop];
      if (val && val[0] && val[0] !== '0' && !isNaN(val)) {
        obj[prop] = +val;
      }
    }
  }
  return obj;
};
//End public method /getReqParam/

function timer_handler(msec, callback) {
  this.msec = msec;
  this.callback = callback;
  this.start_timer = function() {
    this.id = setInterval(this.callback, this.msec);
  };
  this.stop_timer = function() {
    clearInterval(this.id);
  };
}

// function get_record_config(){
//   try{
//     var obj = JSON.parse(fs.readFileSync('../config_file/record_config.json', 'utf8')); // path needed to be modified
//     return obj;
//   }
//   catch(err){
//     return null;
//   }
// };

function arrToEnum(arr, start_indx) {
  var obj = {};
  arr.forEach(function(item, index) {
    obj[item] = index + start_indx;
  });
  return obj;
}

function arrSlice(arr, start_indx) {
  var new_arr;
  if (start_indx >= 0) {
    new_arr = arr;
  } else {
    new_arr = arr.slice(-1 * start_indx);
  }
  return new_arr;
}

function decrypt_remote_text(text) {
  var decrypt_text = '';
  var b = Buffer.from(text, 'base64');
  //var text_bytes = aesjs.util.convertStringToBytes(b);
  var text_bytes = aesjs.utils.utf8.toBytes(b);
  var aes_ctr = new aesjs.ModeOfOperation.ctr(aes_key, new aesjs.Counter(0));
  var decrypted_bytes = aes_ctr.decrypt(text_bytes);
  decrypt_text = aesjs.util.convertBytesToString(decrypted_bytes);
  return decrypt_text;
}

function encrypt_remote_text(text) {
  var encrypt_text = '';
  //var text_bytes = aesjs.util.convertStringToBytes(text);
  var text_bytes = aesjs.utils.utf8.toBytes(text);
  var aes_ctr = new aesjs.ModeOfOperation.ctr(aes_key, new aesjs.Counter(0));
  var encrypted_bytes = aes_ctr.encrypt(text_bytes);
  //encrypt_text = aesjs.util.convertBytesToString(encrypted_bytes);
  var b = Buffer.from(encrypted_bytes);
  encrypt_text = b.toString('base64');
  return encrypt_text;
}

var zeroPad = (function() {
  var cache = {};
  var genZeroStr = function(len) {
    if (cache[len] === undefined) {
      cache[len] = '';
      while (cache[len].length < len) {
        cache[len] += '0';
      }
    }
    return cache[len];
  };
  return function(str, len) {
    if (str.length === len) {
      return str;
    }
    var zeroStr = genZeroStr(len);
    var s = zeroStr + str;
    return s.substr(s.length - len);
  };
})();

function binStrToHexStr(bStr) {
  var res = '';
  var bLen = bStr.length;
  var size = bLen + ((4 - (bLen % 4)) % 4);
  bStr = zeroPad(bStr, size);
  for (var i = 0; i < size; i += 4) {
    var part = bStr.slice(i, i + 4);
    part = parseInt(part, 2);
    part = part.toString(16);
    res += part;
  }
  return res;
}

function hexStrToBinStr(hexStr) {
  var res = '';
  var hLen = hexStr.length;
  for (var i = 0; i < hLen; i++) {
    var part = parseInt(hexStr[i], 16);
    part = zeroPad(part.toString(2), 4);
    res += part;
  }
  return res;
}

function AES() {
  var aesEcb;
  setKey('dynacolor_XMS');

  if (!btoa || !atob) {
    var btoa = function(str) {
      var buffer;

      if (str instanceof Buffer) {
        buffer = str;
      } else {
        buffer = Buffer.from(str.toString(), 'binary');
      }

      return buffer.toString('base64');
    };
    var atob = function(str) {
      return Buffer.from(str, 'base64').toString('binary');
    };
  }

  function hexToBase64(str) {
    return btoa(
      String.fromCharCode.apply(
        null,
        str
          .replace(/\r|\n/g, '')
          .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
          .replace(/ +$/, '')
          .split(' ')
      )
    );
  }

  function base64ToHex(str) {
    for (
      var i = 0, bin = atob(str.replace(/[ \r\n]+$/, '')), hex = [];
      i < bin.length;
      ++i
    ) {
      var tmp = bin.charCodeAt(i).toString(16);
      if (tmp.length === 1) tmp = '0' + tmp;
      hex[hex.length] = tmp;
    }
    return hex.join('');
  }

  function setKey(input) {
    var key = [];
    if (input.length > 16) {
      input = input.substr(0, 16);
    }
    for (var i = 0; i < 16; i++) {
      if (i < input.length) {
        key.push(input.charCodeAt(i));
      } else {
        key.push(0);
      }
    }
    aesEcb = new aesjs.ModeOfOperation.ecb(key);
    return true;
  }

  function encode(input) {
    var enctext = '';
    var leftnum = 0;
    if (aesjs.utils.utf8.toBytes(input).length % 16 != 0) {
      leftnum = 16 - (aesjs.utils.utf8.toBytes(input).length % 16);
    }
    enctext = input;
    for (var i = 0; i < leftnum; i++) {
      enctext += '\0';
    }
    //補上checksum
    enctext += String.fromCharCode(16 + (leftnum % 16));
    for (var i = 0; i < 15; i++) {
      enctext += '\0';
    }
    var enchex = aesjs.utils.hex.fromBytes(
      aesEcb.encrypt(aesjs.utils.utf8.toBytes(enctext))
    );
    var encbase64 = hexToBase64(enchex);
    return encbase64;
  }

  function decode(input) {
    var decbase64 = input;
    var dechex;
    var dectext;
    try {
      dechex = base64ToHex(decbase64);
    } catch (e) {
      console.error('Error when decode base64');
      return false;
    }
    try {
      dectext = aesjs.utils.utf8.fromBytes(
        aesEcb.decrypt(aesjs.utils.hex.toBytes(dechex))
      );
      var checksum = dectext.charCodeAt(dectext.length - 16);
      dectext = dectext.substr(0, dectext.length - checksum);
    } catch (e) {
      console.error('Error when decode aes');
      return false;
    }
    return dectext;
  }
  return {
    setKey: setKey,
    encode: encode,
    decode: decode
  };
}
var aesObj = AES();

module.exports = {
  getReqParam: getReqParam,
  timer_handler: timer_handler,
  // get_record_config: get_record_config,
  arrToEnum: arrToEnum,
  arrSlice: arrSlice,
  encrypt_remote_text: aesObj.encode,
  decrypt_remote_text: aesObj.decode,
  binStrToHexStr: binStrToHexStr,
  hexStrToBinStr: hexStrToBinStr,
  aes: aesObj
};
